<template>
  <div class="Feedback">
    <div class="product-Item">
    <div class="introduction_r">
      <div class="introduction_nameBox">
        <el-page-header @back="goBack" :content="contentName"></el-page-header>
      </div>
    </div>
    <div class="Feedback-main">
      <div class="Feedback-cont">欢迎您对九州泰岳网站提出宝贵意见和建议,我们将充分分析您的意见，作为我们后期网站建设的指导。九州泰岳的成长离不开您的支持，谢谢！您也可以拨打我们客户服务热线：010-62101016-218</div>
      <div class="Feedback-input">
        <textarea class="textarea" id="textArea" @input="inputInfo($event)" v-model="business" placeholder="Hi，请输入你对九州泰岳的反馈或建议吧~"></textarea>
      </div>
      <div class="inputBox">
        <input class="userName" type="text" v-model="userName" placeholder="请输入您的名字">
        <input class="mailbox" type="text" v-model="mailbox" placeholder="请输入您的Email">
        <div class="sendBtn" @click="SubmitBtn">发送</div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      contentName:'',
      business:'',
      userName:'',
      mailbox:'',
      userId:''
    }
  },
  watch: {
    business(){
      this.getHight();
    }
  },
  created(){
    this.contentName = this.$route.query.contentName
  },
  mounted(){
    if(localStorage.getItem("userInfo")){
      this.userId = JSON.parse(localStorage.getItem("userInfo")).userId
    }else{
      this.$message.error('您未登录，请登录！');
    }
  },
  methods:{
    SubmitBtn(){
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if(!localStorage.getItem("userInfo")){
        this.$message.error('您未登录，请登录！');
        return;
      }
      if(this.business.trim()==''){
        this.$message.error('请输入意见或反馈内容');
        return;
      }
      if(this.userName.trim()==''){
        this.$message.error('请输入用户名');
        return;
      }
      if(this.mailbox.trim()==''){
        this.$message.error('请输入您的邮箱');
        return;
      }
      if(!reg.test(this.mailbox)){
        this.$message.error('输入电子邮箱格式不正确');
        return;
      }
      let url = "/feedbackController/front/submitFeedback"
      this.$axios.post(url,{
        content:this.business,
        userName:this.userName,
        email:this.mailbox,
        userId:this.userId
      }).then(res=>{
        console.log(res)
        if(res.data.code==20000){
          this.$message({
            message: '提交成功',
            type: 'success'
          });
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    inputInfo (e) {
      let textArea = document.getElementById('textArea')
      textArea.style.height = '20px'
    },
    getHight () {
      let textArea = document.getElementById('textArea')
      textArea.style.height = textArea.scrollHeight + 'px'
    },
    goBack() {
      // history.go(-1)
      this.$router.go(-1);//返回上一层
    }
  }
}
</script>

<style scoped lang="less">
.product-Item {
  width: 1200px;
  margin: 15px auto;
  .introduction_r {
    // width: calc(1200px - 304px);
    .introduction_nameBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      // margin-bottom: 30px;
      border-bottom: 1px solid #e6e8ed;
      .introduction_name {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .inputBox {
        width: 360px;
        height: 36px;
        // background: #FFFFFF;
        border-radius: 4px;
        // border: 1px solid #1373CF;
      }
    }
    .introduction_cont {
      padding: 20px 0;
      min-height: 500px;
    }
  }
}
.Feedback-main{
  margin-top: 13px;
}
.Feedback-cont{
  font-size: 14px;
  font-family: NotoSansHans-Regular, NotoSansHans;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  letter-spacing: 2px;
}
.Feedback-input{
  width: 100%;
  min-height: 146px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #828282;
  padding: 18px 14px;
  box-sizing: border-box;
  margin-top: 13px;
}
.textarea{
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
}
.inputBox{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.userName{
  width: 480px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #828282;
  padding: 18px 14px;
  box-sizing: border-box;
  outline: 0;
}
.mailbox{
  width: 480px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #828282;
  padding: 18px 14px;
  box-sizing: border-box;
  outline: 0;
}
.sendBtn{
  width: 162px;
  height: 50px;
  background: #1373CF;
  border-radius: 4px;
  font-size: 18px;
  font-family: NotoSansHans-Medium, NotoSansHans;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 50px;
  letter-spacing: 2px;
  text-align: center;
  cursor: pointer;
}
</style>